import { environment } from 'src/environments/environment';

import {
  Component,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Input,
  HostListener,
} from '@angular/core';

@Component({
  selector: 'app-canvas-comp',
  templateUrl: './canvas.component.html',
  styleUrls: ['./canvas.component.css'],
})
export class SCanvasComponent implements AfterViewInit {
  /** Template reference to the canvas element */
  @ViewChild('canvasEl') canvasEl: ElementRef;

  @Input() imageURL: string;
  @Input() fileName: string;
  /** Canvas 2d context */
  context: CanvasRenderingContext2D;

  imageObj = new Image();
  // imageName = "../assets/550.jpg";
  width = window.innerWidth * 0.6;
  height = window.innerHeight;
  canvas: HTMLCanvasElement;
  ocr: any;
  lastItem: any;
  wordClicked: (word: any) => void;

  constructor() {}

  ngOnInit(): void {}
  ngAfterViewInit() {
    this.canvas = this.canvasEl.nativeElement as HTMLCanvasElement;
    if (this.canvasEl.nativeElement) {
      const newCtx = (
        this.canvasEl.nativeElement as HTMLCanvasElement
      ).getContext('2d');
      if (newCtx) this.context = newCtx;
    }

    this.play();
  }

  restart() {
    this.unchooseTr();
    this.ocr = null;
  }
  setOcr(body: any) {
    this.ocr = body.ocr;
    if (body.imgBase64 && body.imgBase64 != '')
      this.imageURL = `data:image/png;base64, ${body.imgBase64}`;
    this.play();
  }
  /**
   * Draws something using the context we obtained earlier on
   */
  draw() {
    this.context.drawImage(this.imageObj, 0, 0, this.width, this.height);
    this.drawItem();
  }

  play() {
    this.imageObj.onload = () => {
      this.height = (this.imageObj.height / this.imageObj.width) * this.width;
      setTimeout(this.draw.bind(this), 100);
    };
    this.imageObj.src = this.imageURL;

    // Create circle
    let ctx = this.context;

    // Listen for mouse down
    this.canvas.addEventListener('mousedown', (event) => {
      if (!this.ocr) return;
      for (let word of this.ocr['responses'][0]['textAnnotations']) {
        const box = this.getWordBox2D(word);
        if (ctx.isPointInPath(box, event.offsetX, event.offsetY)) {
          this.wordClicked(word);
        }
      }
    });
    // Listen for mouse moves
    this.canvas.addEventListener('mousemove', (event) => {
      if (!this.ocr) return;
      let foundFlag = false;
      for (let word of this.ocr['responses'][0]['textAnnotations']) {
        const box = this.getWordBox2D(word);
        if (ctx.isPointInPath(box, event.offsetX, event.offsetY)) {
          this.clear();
          ctx.strokeStyle = 'yellow';
          ctx.stroke(box);
          foundFlag = true;
        }
      }
      if (!foundFlag) {
        this.clear();
      }
    });
  }

  getWordBox2D(word) {
    let x1 = word['boundingPoly']['vertices'][0]['x'];
    let y1 = word['boundingPoly']['vertices'][0]['y'];

    let x2 = word['boundingPoly']['vertices'][2]['x'];
    let y2 = word['boundingPoly']['vertices'][2]['y'];

    [x1, y1] = this.normalize(x1, y1);
    [x2, y2] = this.normalize(x2, y2);

    let w = x2 - x1,
      h = y2 - y1;
    const box = new Path2D();
    box.rect(x1, y1, w, h);
    return box;
  }
  clear() {
    this.draw();
  }

  drawRect(x, y, w, h, strokeStyle = '') {
    this.context.lineWidth = 3;
    this.context.setLineDash([6]);
    this.context.strokeStyle = strokeStyle;
    this.context.beginPath();
    this.context.rect(x, y, w, h);
    this.context.stroke();
  }

  getItemBox(item) {
    if (item.box) {
      return item.box;
    } else {
      return item.value.word.box;
    }
  }

  drawItemWord(item, color, sideFlag = false): [number, number] | null {
    let box = this.getItemBox(item);
    if (box == null) return null;

    return this.drawItemBox(box, color);
  }

  drawItemBox(box, color): [number, number] | null {
    if (box == null) return null;
    let x = 0,
      y = 0,
      w = 0,
      z = 0;
    if (Array.isArray(box)) {
      x = box[0];
      y = box[1];
      w = box[2];
      z = box[3];
    } else {
      x = box.left - 8;
      y = box.bottomLeft - 8;

      z = box.topRight + 8;
      w = box.right + 8;
    }
    [x, y] = this.normalize(x, y);
    [w, z] = this.normalize(w, z);

    this.drawRect(x, y, w - x, z - y, color);
    return [x, y];
  }

  normalize(x: any, y: any): any {
    x *= this.width / this.imageObj.width;
    y *= this.height / this.imageObj.height;
    return [x, y];
  }

  unchooseTr() {
    this.lastItem = null;
  }

  drawItem(): [number, number] | null {
    if (this.lastItem) {
      let item = this.lastItem;
      if (item.box) {
        return this.drawItemBox(item.box, 'red');
      }
      if (item.value) {
        if (item.value.box) {
          return this.drawItemBox(item.value.box, 'red');
        } else {
          return this.drawItemWord(item, 'red');
        }
      }
    }
    return null;
  }

  itemOver(item: any): [number, number] | null {
    this.clear();
    this.lastItem = item;
    return this.drawItem();
  }
}
